import { Vehicle } from '@/models/gen/graphql';
import { searchVehiclesWithMetadata } from '@/features/Vehicles/api/services/searchVehicles';

export namespace VehiclesTypes {
  export type Filters = {
    airportCode: string[];
    active: string;
  };

  export const initFilters: Filters = {
    airportCode: [],
    active: '1',
  };

  export type Modals = {
    editVehicle: { show: boolean } | null;
    createVehicle: { show: boolean } | null;
    vehicleSettings: { show: boolean } | null;
  };

  export const initModals: Modals = {
    editVehicle: null,
    createVehicle: null,
    vehicleSettings: null,
  };

  export type Settings = {
    rememberFilters: boolean;
    columns: {
      SELECT: boolean;
      TAG: boolean;
      VIN: boolean;
      VEHICLE_NO: boolean;
      AIRPORT: boolean;
      EXCHANGE_PLACE: boolean;
      PHONE: boolean;
      STATUS: boolean;
    };
  };

  export const initSettings: Settings = {
    rememberFilters: false,
    columns: {
      SELECT: true,
      TAG: true,
      VIN: true,
      VEHICLE_NO: true,
      AIRPORT: true,
      EXCHANGE_PLACE: true,
      PHONE: true,
      STATUS: true,
    },
  };

  export type Table = {
    search: string;
    sorting: {
      column: string | undefined;
      direction: 'asc' | 'desc' | undefined;
    };
  };

  export const initTable: Table = {
    search: '',
    sorting: {
      column: undefined,
      direction: undefined,
    },
  };

  export type State = {
    vehicles: Vehicle[];
    total: number;
    selected: string[];
    loading: boolean;
    filters: Filters;
    table: Table;
    modals: Modals;
    settings: Settings;
    fetch: () => Promise<void>;
    onSelect: (id: string) => void;
    onReset: () => void;
  };

  export const initState = (setState, getState): State => {
    const fetch = async (): Promise<void> => {
      try {
        setState((current) => ({ ...current, loading: true }));
        const { state } = getState();
        const { vehicles, totalCount } = await searchVehiclesWithMetadata(state.filters);
        setState((current) => ({ ...current, vehicles, total: totalCount, selected: [] }));
      } catch (err) {
        console.error('Error fetching vehicles:', err);
      } finally {
        setState((current) => ({ ...current, loading: false }));
      }
    };

    return {
      vehicles: [],
      total: 0,
      selected: [],
      loading: false,
      filters: initFilters,
      table: initTable,
      modals: initModals,
      settings: initSettings,
      fetch,
      onSelect: (id: string): void => {
        setState((current) => ({
          ...current,
          selected: current.selected.includes(id) ? current.selected.filter((val: string) => val !== id) : [...current.selected, id],
        }));
      },
      onReset: (): void => {
        setState((current) => ({ ...current, filters: initFilters, table: { ...current.table, search: '' } }));
        fetch();
      },
    };
  };
}
